const RS_DATA_PLANE_URL = 'https://allbirds-dataplane.rudderstack.com';
const RS_CONSENT_PROVIDER_ONE_TRUST = 'oneTrust';

export { RS_DATA_PLANE_URL, RS_CONSENT_PROVIDER_ONE_TRUST };
